import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  ref: "audio",
  src: "Mariachi-Music.mp3",
  loop: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WindowTitle = _resolveComponent("WindowTitle")!
  const _component_Green = _resolveComponent("Green")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SlowBlink = _resolveComponent("SlowBlink")!
  const _component_Red = _resolveComponent("Red")!
  const _component_WindowContent = _resolveComponent("WindowContent")!
  const _component_Window = _resolveComponent("Window")!

  return (_openBlock(), _createBlock(_component_Window, { class: "dashboard-public-address" }, {
    default: _withCtx(() => [
      _createVNode(_component_WindowTitle, null, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode(" Public Address System ")
        ])),
        _: 1,
        __: [2]
      }),
      _createVNode(_component_WindowContent, null, {
        default: _withCtx(() => [
          _createElementVNode("table", null, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[5] || (_cache[5] = _createElementVNode("td", null, " Status ", -1)),
                _createElementVNode("td", null, [
                  (!_ctx.playing)
                    ? (_openBlock(), _createBlock(_component_Green, { key: 0 }, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode(" STBY ")
                        ])),
                        _: 1,
                        __: [3]
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.playing)
                    ? (_openBlock(), _createBlock(_component_Green, { key: 1 }, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createTextVNode(" PLAYING ")
                        ])),
                        _: 1,
                        __: [4]
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          (!_ctx.playing)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.playMusic()))
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode(" initiate station-wide broadcast ")
                ])),
                _: 1,
                __: [6]
              }))
            : _createCommentVNode("", true),
          (_ctx.playing)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.stopMusic()))
              }, {
                default: _withCtx(() => [
                  (!_ctx.triedStopping)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, " abort station-wide broadcast "))
                    : _createCommentVNode("", true),
                  (_ctx.triedStopping)
                    ? (_openBlock(), _createBlock(_component_Red, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_SlowBlink, null, {
                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                              _createTextVNode("pa controller failure")
                            ])),
                            _: 1,
                            __: [7]
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("audio", _hoisted_2, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}